import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=070a169e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a169e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070a169e')) {
      api.createRecord('070a169e', component.options)
    } else {
      api.reload('070a169e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=070a169e&scoped=true&", function () {
      api.rerender('070a169e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F0UcIGRT4mck/JS/comp/Accordion.vue"
export default component.exports